<div
  class="row justify-content-between align-items-center"
  [ngStyle]="{ display: entity.isVisible ? 'block' : 'none' }"
>
  <div class="col flex-auto">
    <div
      class="form-group"
      [ngClass]="{ 'pt-0': !showLabel ,    'p-0': templateForPermitForm
}"
      [ngStyle]="{ display: !entity.isCalculating ? 'block' : 'none' }"
    >
      <template #entityContainer></template>
      <!-- Added by Amisha on 17-04-2026: permit-form document uploads show
           their Required message from app.view.component.ts, so the generic
           wrapper control message is skipped there to prevent duplicates. -->
      <wm-control-message
        *ngIf="form && shouldShowControlMessage()"
        [control]="form.controls[entity.templateCode]"
      >
      </wm-control-message>
    </div>
  </div>
  <div class="col-2" *ngIf="entity.canUnlock && entity.isLocked">
    @if (templateForPermitForm) {
 <div class="unlock-button" style="margin-top: 20px;margin-bottom: 20px;" >
        <wm-common-button
        [data]="onUnlockClick()"
        ></wm-common-button>
        </div>
    }@else {
      <div class="unlock-icon">
      <wm-modal-confirm
        [showCommandText]="true"
        [commandText]="'OK'"
        [showButtonText]="true"
        [showButton]="true"
        [buttonText]="'Unlock'"
        [title]="'Edit Entity Value'"
        [buttonClass]="'btn btn-primary btn-raised'"
        (accepted)="unlockEntity()"
      >

        <p>The following Activities depend on this value.</p>
        <ul class="list-group">
          <li
            class="list-group-item"
            *ngFor="let a of entity.completedDependentActivtyInfo"
          >
            {{ a.activityLabel }}
          </li>
        </ul>
      </wm-modal-confirm>
    </div>
    }

  </div>
</div>
<div class="row">
  <div class="col-1">
    <app-loader *ngIf="entity && entity.isCalculating && $any(entity).visibleToUser !== false"></app-loader>
  </div>
</div>
<wm-common-confirmation-modal [data]="unlockModalData" (onYesClick)="handleUnlockModalAccepted()"
    (onNoClick)="handleUnlockModalModalRejected()">
    <div style="display: flex; text-align: start;" >
        <p>The following Activities depend on this value.</p>
        </div>
        <ul class="list-group">
          <li
            class="list-group-item"
            *ngFor="let a of entity.completedDependentActivtyInfo"
          >
            {{ a.activityLabel }}
          </li>
        </ul>
</wm-common-confirmation-modal>
